export default "__VITE_ASSET__JPhYyw6Y__"